
export const comparisonFeatures = [
  {
    feature: 'Vehicle Selection',
    icon: 'ri-car-line',
    broker: 'Access to every make, model, year, and price point nationwide. We search thousands of listings to find your perfect match.',
    dealership: 'Limited to whatever sits on their lot. Warrenton Kia only sells Kia. Lums Toyota only sells Toyota. Astoria Ford only sells Ford.',
    savings: 'Unlimited choices',
  },
  {
    feature: 'Pricing Transparency',
    icon: 'ri-money-dollar-circle-line',
    broker: 'One flat broker fee with zero hidden charges. You see the wholesale price, our fee, and the total. That\'s it.',
    dealership: 'Dealer markup, destination fees, prep fees, advertising fees, documentation fees. Oceancrest Chevrolet and Warrenton Kia pile on $2,000-$4,000 in hidden costs.',
    savings: '$3,000-$8,000',
  },
  {
    feature: 'Negotiation',
    icon: 'ri-discuss-line',
    broker: 'We negotiate on YOUR behalf using wholesale pricing and industry connections. No pressure, no games, no stress.',
    dealership: 'You vs. trained sales professionals at Astoria Ford or Lums Toyota who negotiate for a living. The deck is stacked against you.',
    savings: 'Zero stress',
  },
  {
    feature: 'Trade-In Value',
    icon: 'ri-exchange-line',
    broker: 'We shop your trade-in to multiple buyers and auction houses to get the highest possible value for your vehicle.',
    dealership: 'Dealerships like Oceancrest Chevrolet lowball trade-ins by $1,500-$3,000 to pad their profit margins on the new sale.',
    savings: '$1,500-$3,000 more',
  },
  {
    feature: 'Financing Options',
    icon: 'ri-bank-card-line',
    broker: 'We partner with 20+ lenders and credit unions to find the lowest rate for your credit situation. All credit types welcome.',
    dealership: 'Dealerships mark up interest rates by 1-3% above what the bank offers them. That\'s thousands extra over the life of your loan.',
    savings: '1-3% lower APR',
  },
  {
    feature: 'Time Investment',
    icon: 'ri-time-line',
    broker: 'We do all the searching, negotiating, and paperwork. Most clients spend under 2 hours total on their purchase.',
    dealership: 'Expect 4-8 hours at the dealership per visit. Multiple trips to Warrenton Kia or Astoria Ford before you even test drive.',
    savings: '6+ hours saved',
  },
  {
    feature: 'After-Sale Support',
    icon: 'ri-shield-check-line',
    broker: 'Ongoing relationship with personalized support. We help with warranty claims, service recommendations, and future purchases.',
    dealership: 'Once you drive off the lot, you\'re just another number. Good luck getting Lums Toyota to return your call about that warranty issue.',
    savings: 'Lifetime support',
  },
  {
    feature: 'Pressure Tactics',
    icon: 'ri-emotion-happy-line',
    broker: 'Zero pressure, ever. Take your time, ask questions, change your mind. We work at your pace because we work for you.',
    dealership: '"This deal expires today!" "Someone else is looking at this car!" Classic high-pressure tactics used daily at local dealerships.',
    savings: 'Peace of mind',
  },
];

export const pricingComparison = {
  vehicleExample: '2023 Toyota RAV4 XLE',
  dealership: {
    basePrice: 32500,
    dealerMarkup: 2800,
    destinationFee: 495,
    prepFee: 399,
    advertisingFee: 695,
    docFee: 350,
    total: 37239,
  },
  broker: {
    basePrice: 29800,
    brokerFee: 1495,
    docFee: 150,
    total: 31445,
  },
  savings: 5794,
};

export const competitorComparisons = [
  {
    name: 'Warrenton Kia',
    location: 'Warrenton, OR',
    limitation: 'Only sells Kia vehicles',
    avgMarkup: '$3,200',
    selectionScore: 2,
    transparencyScore: 2,
    serviceScore: 3,
  },
  {
    name: 'Lums Toyota',
    location: 'Warrenton, OR',
    limitation: 'Only sells Toyota vehicles',
    avgMarkup: '$3,800',
    selectionScore: 2,
    transparencyScore: 2,
    serviceScore: 2,
  },
  {
    name: 'Astoria Ford',
    location: 'Astoria, OR',
    limitation: 'Only sells Ford vehicles',
    avgMarkup: '$2,900',
    selectionScore: 2,
    transparencyScore: 3,
    serviceScore: 3,
  },
  {
    name: 'Oceancrest Chevrolet',
    location: 'Warrenton, OR',
    limitation: 'Only sells Chevrolet vehicles',
    avgMarkup: '$3,500',
    selectionScore: 2,
    transparencyScore: 2,
    serviceScore: 2,
  },
];

export const customerWins = [
  {
    name: 'Sarah M.',
    location: 'Astoria, OR',
    vehicle: '2022 Honda CR-V',
    savedAmount: 4200,
    quote: 'I was about to buy from Lums Toyota when a friend told me about Rockhound Auto. They found me a better Honda CR-V for $4,200 less than what Lums was asking for a comparable Toyota. Plus, I actually got the brand I wanted!',
    competitor: 'Lums Toyota',
    avatar: 'SM',
  },
  {
    name: 'Mike & Jennifer T.',
    location: 'Seaside, OR',
    vehicle: '2023 Ford F-150',
    savedAmount: 6800,
    quote: 'Astoria Ford wanted $52,000 for an F-150. Rockhound found us the exact same truck with fewer miles for $45,200. We couldn\'t believe the difference. The whole process took one afternoon instead of three weekends at the dealership.',
    competitor: 'Astoria Ford',
    avatar: 'MT',
  },
  {
    name: 'David R.',
    location: 'Longview, WA',
    vehicle: '2022 Chevrolet Silverado',
    savedAmount: 5500,
    quote: 'Oceancrest Chevrolet gave me $8,000 for my trade-in. Rockhound got me $11,500 from a different buyer and found me a newer Silverado for less money. I saved over $5,500 total. Never going back to a dealership.',
    competitor: 'Oceancrest Chevrolet',
    avatar: 'DR',
  },
  {
    name: 'Lisa K.',
    location: 'Tillamook, OR',
    vehicle: '2023 Kia Sportage',
    savedAmount: 3800,
    quote: 'Warrenton Kia had a Sportage I liked but the price was way too high and they wouldn\'t budge. Rockhound found me a newer model with more features for $3,800 less. The no-pressure experience was refreshing.',
    competitor: 'Warrenton Kia',
    avatar: 'LK',
  },
  {
    name: 'Tom & Carol B.',
    location: 'Forest Grove, OR',
    vehicle: '2023 Subaru Outback',
    savedAmount: 4600,
    quote: 'No local dealership even had the Outback we wanted. Rockhound sourced it from Portland, negotiated a great price, and delivered it to our door in Forest Grove. Saved us $4,600 and a ton of hassle.',
    competitor: 'Multiple dealerships',
    avatar: 'TB',
  },
  {
    name: 'Rachel W.',
    location: 'Kelso, WA',
    vehicle: '2022 Toyota Tacoma',
    savedAmount: 5100,
    quote: 'Living in Washington, I still pay WA use tax when I register — but Rockhound\'s pricing beat what Lums Toyota quoted me by over $5,000. No dealer markup, no hidden fees, and they handled all the cross-state paperwork. Easiest car purchase I\'ve ever made.',
    competitor: 'Lums Toyota',
    avatar: 'RW',
  },
];

export const dealershipTactics = [
  {
    tactic: 'The Four-Square Method',
    icon: 'ri-layout-grid-line',
    description: 'Dealerships juggle trade-in value, purchase price, down payment, and monthly payment to confuse you. They shift numbers between boxes so you never see the real cost.',
  },
  {
    tactic: 'Bait and Switch',
    icon: 'ri-exchange-funds-line',
    description: 'Advertised price gets you in the door, then "that car just sold" and they steer you to a more expensive option. Common at Warrenton Kia and Astoria Ford.',
  },
  {
    tactic: 'Payment Packing',
    icon: 'ri-stack-line',
    description: 'The finance office bundles warranties, gap insurance, and add-ons into your monthly payment without clearly disclosing each cost. Thousands added before you notice.',
  },
  {
    tactic: 'Lowball Trade-In',
    icon: 'ri-arrow-down-circle-line',
    description: 'Oceancrest Chevrolet and Lums Toyota routinely offer $1,500-$3,000 below market value for trade-ins, then resell them at full retail price.',
  },
  {
    tactic: 'Artificial Urgency',
    icon: 'ri-alarm-warning-line',
    description: '"This price is only good today!" "Another buyer is coming at 3pm!" These pressure tactics are designed to prevent you from shopping around.',
  },
  {
    tactic: 'Rate Markup',
    icon: 'ri-percent-line',
    description: 'Banks approve you at 5% but the dealership tells you 7.5% and pockets the difference. This costs you thousands over a 5-year loan.',
  },
];
